import {CoordenadasPontoChegadaModel} from '../components/roteirizacao/models/coordenadas-ponto-chegada.model';

export class RotaSequenciaDtoModel {
  dataPrimeiraEntrega?: Date;
  dataUltimaEntrega?: Date;
  dataSaidaCD?: Date;
  dataRetornoCD?: Date;
  pontoChegada?: CoordenadasPontoChegadaModel;
}
